import 'twin.macro';
import React, { useState } from 'react';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { ArrowRightIcon as ArrowRight } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { GradeSelector } from '../School/New/GradeSelector';
import { useScholarSystem } from 'queries/user/useScholarSystem';
import _groupBy from 'lodash-es/groupBy';
import { ScholarSystems } from 'containers/scholarSystem';

interface Props {
  onSubmit: (grades: string[]) => void;
  onCancel: () => void;
  value: string[];
  skipPrefillLastYear: boolean;
}

export function Step3(props: Props) {
  const { onSubmit, onCancel } = props;
  const { t } = useTranslation(['common']);
  const [grades, setGrades] = useState<string[]>(props.value || []);
  const { scholarSystem = ScholarSystems.FR } = useScholarSystem();
  const groupedGradeOptions = Object.values(
    _groupBy(scholarSystem.niveaux, n => n.category),
  ).map(g => g.map(v => v.niveau));

  return (
    <div>
      <div tw="mb-10">
        <GradeSelector
          groupedOptions={groupedGradeOptions}
          value={grades}
          onChange={setGrades}
        />
      </div>
      <div tw="flex justify-center space-x-4 items-center">
        <Button large minimal onClick={onCancel}>
          {t('common:buttons.previous')}
        </Button>
        <Button
          intent="primary"
          onClick={() => onSubmit(grades)}
          large
          rightIcon={ArrowRight}
          disabled={grades.length === 0}
        >
          {grades.length > 1 || !props.skipPrefillLastYear
            ? t('common:buttons.next')
            : t('common:buttons.create')}
        </Button>
      </div>
    </div>
  );
}
